import React, {FC, useState} from 'react';

import {FormContext} from './context';

export interface IAppFormProps extends React.ComponentProps<'form'> {}

export const AppForm: FC<IAppFormProps> = ({children, onSubmit, ...rest}) => {
    const [values, setValues] = useState<Record<string, any>>({});

    const setFieldValue = (name: string, value: any) => {
        setValues((prev) => ({...prev, [name]: value}));
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onSubmit?.(e);
    };

    return (
        <FormContext.Provider value={{values, setFieldValue}}>
            <form onSubmit={handleSubmit} className='space-y-6' {...rest}>
                {children}
            </form>
        </FormContext.Provider>
    );
};
